import Axios from 'axios';
import config from '../config';
import { saveAuthSession } from './authSession';

export const refreshToken = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  return Axios.post(config.apiBaseUrl + 'refresh-token', undefined, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return saveAuthSession(response.data);
    })
    .catch(() => {
      localStorage.removeItem('accessToken');
      return null;
    });
};
